"use strict";

function pdTabsRoot() {
  return window.Shopify?.routes?.root || "/";
}

function pdTabsMoney(centavos) {
  const valor = (Number(centavos) / 100).toFixed(2).replace(".", ",");
  return `R$ ${valor}`;
}

function pdTabsEsc(texto) {
  return String(texto || "").replace(/[&<>"']/g, (c) => ({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
  })[c]);
}

function pdTabsCheckoutUrl(cupom) {
  const url = new URL(`${pdTabsRoot()}checkout`, window.location.origin);
  if (cupom) url.searchParams.set("discount", cupom);
  return `${url.pathname}${url.search}`;
}

function pdTabsParseConfig(sectionId) {
  const el = document.getElementById(`pd-tabs-cafes-${sectionId}-config`);
  try {
    const parsed = JSON.parse(el?.textContent || "{}");
    return { cupom: String(parsed.cupom || "").trim(), sectionId };
  } catch (e) {
    return { cupom: "", sectionId };
  }
}

async function pdTabsAddItem(id, quantity) {
  const res = await fetch(`${pdTabsRoot()}cart/add.js`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) }] }),
  });
  const data = await res.json();
  if (data.status) throw new Error(data.description || "Não foi possível adicionar");
  return data;
}

async function pdTabsCart() {
  const res = await fetch(`${pdTabsRoot()}cart.js`);
  if (!res.ok) throw new Error("cart.js");
  return res.json();
}

async function pdTabsChangeItem(key, quantity) {
  const res = await fetch(`${pdTabsRoot()}cart/change.js`, {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ id: key, quantity: Number(quantity) }),
  });
  if (!res.ok) throw new Error("change.js");
  return res.json();
}

function pdTabsInit(root) {
  const sectionId = root.getAttribute("data-section-id");
  const cfg = pdTabsParseConfig(sectionId);
  const modal = document.getElementById(`pd-tabs-modal-${sectionId}`);
  const toast = document.getElementById(`pd-tabs-toast-${sectionId}`);
  const drawer = document.getElementById(`pd-tabs-carrinho-${sectionId}`);

  function openModal(card) {
    if (!modal) return;
    const img = card.querySelector(".pd-produto-card__imagem");
    const titulo = card.querySelector(".pd-produto-card__nome");
    const modalImg = document.getElementById(`pd-tabs-modal-imagem-${sectionId}`);
    const modalTitulo = document.getElementById(`pd-tabs-modal-titulo-${sectionId}`);
    if (modalImg && img) {
      modalImg.src = img.src;
      modalImg.alt = img.alt || "";
    }
    if (modalTitulo && titulo) modalTitulo.textContent = titulo.textContent;
    const desc = document.getElementById(`pd-tabs-modal-descricao-${sectionId}`);
    if (desc) {
      desc.textContent = "";
      const p = document.createElement("p");
      p.textContent = card.getAttribute("data-descricao-curta") || "";
      desc.appendChild(p);
    }
    const set = (id, attr) => {
      const el = document.getElementById(id);
      if (el) el.textContent = card.getAttribute(attr) || "-";
    };
    set(`pd-tabs-modal-regiao-${sectionId}`, "data-regiao");
    set(`pd-tabs-modal-notas-${sectionId}`, "data-notas-sensoriais");
    set(`pd-tabs-modal-torra-${sectionId}`, "data-torra");
    set(`pd-tabs-modal-variedade-${sectionId}`, "data-variedade");
    modal.classList.add("show");
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    modal?.classList.remove("show");
    if (!drawer?.classList.contains("show")) document.body.style.overflow = "";
  }

  function showToast(mensagem) {
    if (!toast) return;
    const msg = toast.querySelector(".pd-toast__message");
    if (msg) msg.textContent = mensagem;
    toast.classList.add("show");
    setTimeout(() => toast.classList.remove("show"), 3000);
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("show");
    document.body.style.overflow = "hidden";
  }

  function closeDrawer() {
    drawer?.classList.remove("show");
    document.body.style.overflow = "";
  }

  function renderCart(cart) {
    const count = Number(cart.item_count) || 0;
    const total = Number(cart.total_price) || 0;
    const contador = document.getElementById(`pd-tabs-header-contador-${sectionId}`);
    if (contador) {
      contador.textContent = String(count);
      contador.classList.toggle("show", count > 0);
    }
    const totalDrawer = document.getElementById(`pd-tabs-carrinho-total-${sectionId}`);
    const itensDrawer = document.getElementById(`pd-tabs-carrinho-itens-${sectionId}`);
    if (totalDrawer) totalDrawer.textContent = pdTabsMoney(total);
    if (itensDrawer) itensDrawer.textContent = String(count);
    const checkout = document.getElementById(`pd-tabs-carrinho-checkout-${sectionId}`);
    if (checkout) {
      checkout.href = pdTabsCheckoutUrl(cfg.cupom);
      checkout.classList.toggle("is-disabled", count === 0);
    }
    const container = document.getElementById(`pd-tabs-carrinho-produtos-${sectionId}`);
    if (container) {
      const items = cart.items || [];
      if (!items.length) {
        container.innerHTML = '<p class="pd-carrinho__vazio">Seu carrinho está vazio.</p>';
      } else {
        container.innerHTML = items
          .map(
            (item) => `
      <div class="pd-carrinho-item" data-key="${pdTabsEsc(item.key)}">
        <img src="${pdTabsEsc(item.image || "")}" alt="${pdTabsEsc(item.product_title || "")}" class="pd-carrinho-item__imagem">
        <div class="pd-carrinho-item__coluna">
          <div class="pd-carrinho-item__nome">${pdTabsEsc(item.product_title || "")}</div>
          <div class="pd-carrinho-item__preco">${pdTabsMoney(item.final_line_price || item.line_price || 0)}</div>
        </div>
        <div class="pd-carrinho-item__quantidade">
          <button class="pd-carrinho-item__qtd-btn" data-action="diminuir" type="button" aria-label="Diminuir">-</button>
          <span class="pd-carrinho-item__qtd-valor">${item.quantity}</span>
          <button class="pd-carrinho-item__qtd-btn" data-action="aumentar" type="button" aria-label="Aumentar">+</button>
        </div>
      </div>`
          )
          .join("");
      }
    }
  }

  async function syncCart() {
    const cart = await pdTabsCart();
    renderCart(cart);
    return cart;
  }

  root.querySelectorAll(".pd-tab-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      const tab = btn.getAttribute("data-tab");
      root.querySelectorAll(".pd-tab-btn").forEach((b) => {
        b.classList.remove("active");
        b.setAttribute("aria-selected", "false");
      });
      root.querySelectorAll(".pd-tab-pane").forEach((p) => p.classList.remove("active"));
      btn.classList.add("active");
      btn.setAttribute("aria-selected", "true");
      document.getElementById(`pd-tabs-${sectionId}-${tab}`)?.classList.add("active");
    });
  });

  root.querySelectorAll(".pd-produto-card__qtd-btn").forEach((btn) => {
    btn.addEventListener("click", () => {
      const wrap = btn.closest(".pd-produto-card__quantidade, .pd-destaque__acoes");
      const valorEl = wrap?.querySelector(".pd-produto-card__qtd-valor");
      let valor = parseInt(valorEl?.textContent || "1", 10);
      if (btn.textContent.trim() === "+") valor += 1;
      else valor = Math.max(1, valor - 1);
      if (valorEl) valorEl.textContent = String(valor);
    });
  });

  root.querySelectorAll(".pd-produto-card__adicionar").forEach((btn) => {
    btn.addEventListener("click", async () => {
      const card = btn.closest(".pd-produto-card");
      if (!card) return;
      const id = card.getAttribute("data-id");
      const nome = card.querySelector(".pd-produto-card__nome")?.textContent?.trim() || "Produto";
      const qtd = parseInt(card.querySelector(".pd-produto-card__qtd-valor")?.textContent || "1", 10);
      const original = btn.textContent;
      btn.disabled = true;
      try {
        await pdTabsAddItem(id, qtd);
        await syncCart();
        openDrawer();
        btn.textContent = "Adicionado ✓";
        showToast(`"${nome}" adicionado!`);
      } catch (e) {
        showToast(e.message || "Não foi possível adicionar");
      } finally {
        setTimeout(() => {
          btn.textContent = original;
          btn.disabled = false;
        }, 1500);
      }
    });
  });

  root.querySelectorAll(".pd-produto-card").forEach((card) => {
    [".pd-produto-card__imagem-container", ".pd-produto-card__nome", ".pd-produto-card__lupa", ".pd-destaque__imagem"].forEach(
      (sel) => {
        const el = card.querySelector(sel);
        if (!el) return;
        el.addEventListener("click", (e) => {
          if (!e.target.closest("button")) openModal(card);
        });
      }
    );
  });

  document.getElementById(`pd-tabs-header-carrinho-${sectionId}`)?.addEventListener("click", openDrawer);
  document.getElementById(`pd-tabs-carrinho-fechar-${sectionId}`)?.addEventListener("click", closeDrawer);
  drawer?.querySelector(".pd-carrinho__overlay")?.addEventListener("click", closeDrawer);
  document.getElementById(`pd-tabs-carrinho-produtos-${sectionId}`)?.addEventListener("click", async (e) => {
    const qtdBtn = e.target.closest(".pd-carrinho-item__qtd-btn");
    if (!qtdBtn) return;
    const item = qtdBtn.closest(".pd-carrinho-item");
    const key = item?.getAttribute("data-key");
    const atual = parseInt(item?.querySelector(".pd-carrinho-item__qtd-valor")?.textContent || "1", 10);
    const next = qtdBtn.dataset.action === "aumentar" ? atual + 1 : atual - 1;
    try {
      const cart = await pdTabsChangeItem(key, Math.max(0, next));
      renderCart(cart);
    } catch (err) {
      showToast("Não foi possível atualizar o carrinho");
    }
  });

  document.getElementById(`pd-tabs-modal-fechar-${sectionId}`)?.addEventListener("click", closeModal);
  modal?.querySelector(".pd-modal__overlay")?.addEventListener("click", closeModal);
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    closeModal();
    closeDrawer();
  });

  syncCart().catch(() => {});
}

function pdTabsCupomAtivo() {
  const configs = document.querySelectorAll('[id^="pd-tabs-cafes-"][id$="-config"]');
  let cupom = "";
  configs.forEach((el) => {
    try {
      const parsed = JSON.parse(el.textContent || "{}");
      if (parsed.cupom) cupom = String(parsed.cupom).trim();
    } catch (e) {
      /* ignore */
    }
  });
  return cupom;
}

function pdTabsBindCheckout() {
  if (window.__pdTabsCupomClick) return;
  window.__pdTabsCupomClick = true;
  document.addEventListener("click", (e) => {
    const cupom = pdTabsCupomAtivo();
    if (!cupom) return;
    const link = e.target.closest('a[href*="/checkout"]');
    if (!link) return;
    try {
      const url = new URL(link.href, window.location.origin);
      if (url.searchParams.get("discount") === cupom) return;
      e.preventDefault();
      url.searchParams.set("discount", cupom);
      window.location.href = url.toString();
    } catch (err) {
      /* ignore */
    }
  });
}

function pdTabsBoot() {
  document.querySelectorAll("[data-pd-tabs-cafes]").forEach((root) => {
    if (root.dataset.pdTabsReady) return;
    root.dataset.pdTabsReady = "true";
    pdTabsInit(root);
  });
  pdTabsBindCheckout();
}

if (!window.__pdTabsCafesBoot) {
  window.__pdTabsCafesBoot = true;
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", pdTabsBoot);
  } else {
    pdTabsBoot();
  }
} else if (document.readyState !== "loading") {
  pdTabsBoot();
}
